import { speed } from "jquery";
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  EffectCreative,
  EffectCoverflow,
} from "swiper/modules";
export class W3ReferenceSlider {
  swiper: Swiper | null = null;
  swiperElement: HTMLElement | null;
  slides: NodeListOf<HTMLElement> | null;
  slidesContainer: HTMLElement | null;

  constructor() {
    this.slides = document.querySelectorAll(".reference-cards__slide");
    this.swiperElement = document.querySelector(".reference-cards__swiper");
    if (this.swiperElement) {
      this.slidesContainer =
        this.swiperElement?.querySelector(".swiper-wrapper");
    }
    this.initSlider();
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  private duplicateSlides(): void {
    if (!this.slidesContainer || !this.slides) return;

    Array.from(this.slides).forEach((slide) => {
      const clone = slide.cloneNode(true) as HTMLElement;
      this.slidesContainer!.appendChild(clone);
    });
  }

  /**
   * Initialize or reinitialize the slider based on the current viewport size and slide count.
   */
  private initSlider(): void {
    const slidesPerView = this.getSlidesPerView();
    if (slidesPerView === 0) {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      return;
    }

    if (this.swiper) {
      this.swiper.update();
      return;
    }

    this.duplicateSlides();

    const swiper = new Swiper(".reference-cards__swiper", {
      modules: [Navigation, Pagination],
      slidesPerView: slidesPerView,
      spaceBetween: 28,
      loop: true,
      initialSlide: 2,
      speed: 600,
      freeMode: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".reference__pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1,
      },
      on: {
        slideChange: function (swiper) {
          swiper.slides.forEach((slide) => {
            slide.classList.remove("small-prev", "small-next");
          });
          if (swiper.activeIndex === 0) {
            //set last slide to small-prev
            swiper.slides[swiper.slides.length - 1].classList.add("small-prev");
          } else {
            swiper.slides[swiper.activeIndex - 1].classList.add("small-prev");
          }
          if (swiper.activeIndex >= swiper.slides.length - 3) {
            //set first slide to small-next
            swiper.slides[0].classList.add("small-next");
          } else {
            swiper.slides[swiper.activeIndex + 2].classList.add("small-next");
          }
        },
      },
    });
  }

  /**
   * Determine the appropriate number of slides per view based on the viewport width.
   */
  private getSlidesPerView(): number {
    const isDesktop = window.innerWidth >= 1024;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
    const isMobile = window.innerWidth < 768;

    if (isDesktop && this.slides.length >= 4) {
      return 2;
    }
    if (isTablet && this.slides.length >= 3) return 2;
    if (isMobile && this.slides.length >= 2) return 1;
    return 0; // Do not initialize if conditions are not met
  }

  /**
   * Handle window resize events.
   */
  private handleResize(): void {
    const currentSlidesPerView = this.swiper
      ? this.swiper.params.slidesPerView
      : 0;
    const newSlidesPerView = this.getSlidesPerView();

    // Reinitialize only if the number of slides per view should change
    if (currentSlidesPerView !== newSlidesPerView) {
      this.initSlider();
    }
  }
}
